<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<mat-nav-list class="sidebar-container">
  <div>
    <mat-list-item
      [routerLink]="['/admin/tournaments']"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon matListItemIcon>event_note</mat-icon>
      <div matListItemTitle>Tournaments</div>
    </mat-list-item>
    @if (this.tournament() !== null) {
      <mat-list-item
        [routerLink]="['/admin/tournaments', this.tournament()?.id]"
        routerLinkActive="active-link"
      >
        <mat-icon matListItemIcon>leaderboard</mat-icon>
        <div matListItemTitle>{{ this.tournament()?.name }}</div>
      </mat-list-item>
      <mat-list-item
        [routerLink]="['/admin/tournaments', this.tournament()?.id, 'qualification-phase']"
        routerLinkActive="active-link"
      >
        <div matListItemTitle class="list-item-sub-title">Qualification phase</div>
      </mat-list-item>
      <mat-list-item
        [routerLink]="['/admin/tournaments', this.tournament()?.id, 'ko-phase']"
        routerLinkActive="active-link"
      >
        <div matListItemTitle class="list-item-sub-title">Knockout phase</div>
      </mat-list-item>
      <mat-list-item
        [routerLink]="['/admin/tournaments', this.tournament()?.id, 'tables']"
        routerLinkActive="active-link"
      >
        <div matListItemTitle class="list-item-sub-title">Tables</div>
      </mat-list-item>
      <mat-list-item
        [routerLink]="['/admin/tournaments', this.tournament()?.id, 'teams']"
        routerLinkActive="active-link"
      >
        <div matListItemTitle class="list-item-sub-title">Teams</div>
      </mat-list-item>
    }
  </div>
  <div>
    <mat-list-item routerLinkActive="active-link">
      <mat-icon matListItemIcon>person</mat-icon>
      <div matListItemTitle [routerLink]="['/admin/details', this.username]">Account Information</div>
    </mat-list-item>
    <mat-list-item (click)="logout()" routerLinkActive="active-link" data-cy="logout-button">
      <mat-icon matListItemIcon>logout</mat-icon>
      <div matListItemTitle>Logout</div>
    </mat-list-item>
  </div>
</mat-nav-list>
